export enum userManagementGetUsersEnum {
	ACTIVE = 'active',
	INACTIVE = 'inactive',
	ALL = 'all'
}